import { AnalyticsContext } from '@carvana/eventable-clickstream';
import type { InventoryVehicle } from '@carvana/merch-contracts';
import { useContext } from 'react';
import SectionWrapper from '@/home/common/SectionWrapper';
import VehicleCarousel from '@/home/common/VehicleCarousel';
import VehicleTile from '@/home/common/VehicleCarousel/VehicleTile';
import Sections from '~/constants/home/sections';
import { useFavoritesIds } from '~/context/common/UserContext';
import AvailabilityAndPriceContext from '~/context/home/AvailabilityAndPriceContext';
import { useToggleFavorite } from '~/hooks/common/favorites';
import useTileSharedProps from '~/hooks/home/useTileSharedProps';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

type OwnProps = {
  analyticSection: string;
  title: string;
  showBorder?: boolean;
  vehicles: InventoryVehicle[];
};

function RecCarousel({
  title,
  vehicles,
  showBorder = true,
  analyticSection
}: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    pageAvailability: { data: availabilityData },
    pagePricing: { data: pricingData }
  } = useContext(AvailabilityAndPriceContext);
  const favoriteIds = useFavoritesIds();
  const toggleFavorite = useToggleFavorite();
  const sharedProps = useTileSharedProps();

  function sendClickEvent(vehicleId: number) {
    trackEvent('Home feed card', {
      action: 'clicked',
      description: `${title} tile`,
      vehicleId
    });
  }

  return (
    <SectionWrapper analyticsSection={analyticSection}>
      <VehicleCarousel hasBottomBorder={showBorder} headerTitle={title}>
        {vehicles.map(vehicle => {
          const { vehicleId } = vehicle;

          const tileAvailability = availabilityData[vehicleId];

          return (
            <VehicleTile
              availabilityInfo={{
                pickup: tileAvailability?.soonestPickup?.content ?? undefined,
                delivery:
                  tileAvailability?.soonestDelivery?.content ?? undefined
              }}
              favoriteIds={favoriteIds}
              financeInfo={pricingData[vehicleId] ?? undefined}
              key={vehicleId}
              vehicle={vehicle}
              sectionTitle="Recommended Carousel"
              sharedProps={sharedProps}
              toggleFavorite={toggleFavorite}
              handleTileClick={() => sendClickEvent(vehicleId)}
            />
          );
        })}
      </VehicleCarousel>
    </SectionWrapper>
  );
}

export default withErrorBoundary(
  RecCarousel,
  undefined,
  undefined,
  Sections.Recommended
);
